import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const MissionReportPage_ReportInfo_Fragment = graphql(`
  fragment MissionReportPage_ReportInfo_Fragment on ReportInfo {
    _id
    reportId
    stateId
    workflowId
  }
`);

export type MissionReportPage_ReportInfo = ResultOf<
  typeof MissionReportPage_ReportInfo_Fragment
>;
